// store.ts
import { configureStore } from '@reduxjs/toolkit';
// import authReducer from './authSlice';
import authSlice from '../component/Auth/authSlice';
const store = configureStore({
  reducer: {
    auth: authSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;